import { EventEmitter } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
var DuplicateIdentificationTypeDirective = /** @class */ (function () {
    function DuplicateIdentificationTypeDirective(_commonService) {
        this._commonService = _commonService;
        this.duplicateGovIdTypeFound = new EventEmitter();
    }
    Object.defineProperty(DuplicateIdentificationTypeDirective.prototype, "index", {
        set: function (value) {
            this._index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DuplicateIdentificationTypeDirective.prototype, "formData", {
        set: function (value) {
            this._formData = value;
        },
        enumerable: true,
        configurable: true
    });
    DuplicateIdentificationTypeDirective.prototype.onChange = function (event) {
        var _this = this;
        var governmentIdentificationForm = this._formData.get('govermentIdentification');
        var currentIdentification = governmentIdentificationForm.controls[this._index].controls['governmentIdType'].value;
        var currentCountry = governmentIdentificationForm.controls[this._index].controls['country'].value;
        var idType = currentIdentification.identificationType;
        var isDuplicate = governmentIdentificationForm.controls.find(function (item, index) {
            return index != _this._index && item.controls['country'].value == currentCountry && item.controls['governmentIdType'].value.identificationType == idType;
        });
        if (isDuplicate) {
            this.duplicateGovIdTypeFound.emit("Multiple " + idType + " are not allowed for same country.");
            //this._commonService.createNotification('',"Multiple "+type+" are not allowed for same country.", NotificationType.ERROR,5000);
            governmentIdentificationForm.controls[this._index].controls['governmentIdType'].setValue('');
            governmentIdentificationForm.controls[this._index].controls['governmentIdType'].updateValueAndValidity();
        }
        else {
            this.duplicateGovIdTypeFound.emit(null);
        }
    };
    return DuplicateIdentificationTypeDirective;
}());
export { DuplicateIdentificationTypeDirective };



// WEBPACK FOOTER //
// ./src/app/customerservice/directive/duplicate-identification-type.directive.ts.pre-build-optimizer.js